import { AttributeFilter } from 'app/shared/ui/models/attribute-filter';

export class NumberAttributeFilter implements AttributeFilter {
  attribute: string;
  label: string;
  operator: string;
  value?: number;
  tempValue?: number;
  secondValue?: number;
  tempSecondValue?: number;

  constructor(attribute: string, label: string, operator: string, value?: number, secondValue?: number) {
    this.attribute = attribute;
    this.label = label;
    this.operator = operator;
    this.value = value;
    this.secondValue = secondValue;
  }

  updateValue(): any {
    const filters = Object.create({});
    if (!this.isChecked()) {
      return filters;
    }
    this.value = this.tempValue;
    if (this.operator !== 'between') {
      filters[this.attribute + '.' + this.operator] = this.value;
      this.secondValue = this.tempSecondValue;
    } else {
      filters[this.attribute + '.greaterThanOrEqual'] = this.value;
      this.secondValue = this.tempSecondValue;
      filters[this.attribute + '.lessThanOrEqual'] = this.secondValue;
    }
    return filters;
  }

  isChecked(): boolean {
    if (this.tempValue && this.operator !== 'between') {
      return true;
    }
    return this.operator === 'between' && !!this.tempSecondValue;
  }

  htmlButtonText(): string {
    let htmlContent = '';
    if (this.isChecked()) {
      htmlContent += '<b>' + this.label + '</b> ';
      if (this.operator === 'between') {
        htmlContent +=
          'entre <b>' +
          (this.value === undefined ? '' : this.value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })) +
          '</b> et <b>' +
          (this.secondValue === undefined ? '' : this.secondValue.toLocaleString('fr-FR', { maximumFractionDigits: 2 })) +
          '</b>';
      } else {
        if (this.operator === 'equals') {
          htmlContent += 'égal à';
        } else if (this.operator === 'greaterThan') {
          htmlContent += 'supérieur à';
        } else if (this.operator === 'lessThan') {
          htmlContent += 'inférieur à';
        }
        htmlContent += ' ' + (this.value === undefined ? '' : this.value.toLocaleString('fr-FR', { maximumFractionDigits: 2 }));
      }
    }
    return htmlContent;
  }
}
